export default __webpack_public_path__ + "static/media/Ben Allen.cb6b853d.jpg";